import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.396 10.527l2.61 1.5 2.612-1.5m-2.611 1.5v2.5m0 2.5v2.814m6.75-3.897l-2.442-1.417M5.257 15.944l2.442-1.417m4.308-7.186V4.527m-6.75 3.897l2.442 1.417m11.058-1.417l-2.442 1.417M9.44 18.36l2.567 1.481 2.567-1.482m0-12.349l-2.567-1.483L9.44 6.01m6.75 11.417l2.567-1.482V12.98m0-1.592V8.424L16.19 6.942M7.824 17.427l-2.567-1.482V12.98m0-1.592V8.424l2.567-1.482"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M23.257 12.004c0 6.214-5.039 11.254-11.253 11.254C5.788 23.258.75 18.218.75 12.004.75 5.789 5.788.75 12.004.75c6.214 0 11.253 5.039 11.253 11.254z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.396 10.527l2.61 1.5 2.612-1.5m-2.611 1.5v2.5m0 2.5v2.814m6.75-3.897l-2.442-1.417M5.257 15.944l2.442-1.417m4.308-7.186V4.527m-6.75 3.897l2.442 1.417m11.058-1.417l-2.442 1.417M9.44 18.36l2.567 1.481 2.567-1.482m0-12.349l-2.567-1.483L9.44 6.01m6.75 11.417l2.567-1.482V12.98m0-1.592V8.424L16.19 6.942M7.824 17.427l-2.567-1.482V12.98m0-1.592V8.424l2.567-1.482"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M23.257 12.004c0 6.214-5.039 11.254-11.253 11.254C5.788 23.258.75 18.218.75 12.004.75 5.789 5.788.75 12.004.75c6.214 0 11.253 5.039 11.253 11.254z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.791 21.054l5.223 3 5.224-3m-5.223 3v5m0 5v5.628m13.499-7.794l-4.884-2.834m-22.115 2.834l4.884-2.834m8.616-14.371V9.055m-13.5 7.794l4.884 2.834m22.115-2.834l-4.884 2.834M18.88 36.718l5.135 2.964 5.134-2.964m-.001-24.699l-5.134-2.964-5.134 2.964m13.5 22.834l5.135-2.964V25.96m-.001-3.184V16.85l-5.134-2.965M15.648 34.853l-5.134-2.964V25.96m.001-3.184V16.85l5.134-2.965"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M46.514 24.007c0 12.43-10.078 22.508-22.506 22.508-12.43 0-22.508-10.078-22.508-22.508S11.576 1.499 24.01 1.499c12.428 0 22.505 10.078 22.505 22.508z",
    clipRule: "evenodd"
  }))
};
export var VR = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});